'use strict';

exports.__esModule = true;
exports.default = getCurrentHref;

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCurrentHref() {
  if (!_canUseDom2.default) {
    return 'https://www.facebook.com';
  }

  return location.href;
}
//# sourceMappingURL=getCurrentHref.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/utils/getCurrentHref.js
// module id = 89
// module chunks = 67997519577666